module.exports = __webpack_public_path__ + "img/carscience-logo-dark.9b12bef8.svg";